export const textileConstants = {
  SET_AUTOMATIC_WASH_CODES_LOADING: 'textile/SET_AUTOMATIC_WASH_CODES_LOADING',
  GET_AUTOMATIC_WASH_CODES: 'textile/GET_AUTOMATIC_WASH_CODES',
  SET_AUTOMATIC_WASH_CODES: 'textile/SET_AUTOMATIC_WASH_CODES',
  CLEAR_AUTOMATIC_WASH_CODES: 'textile/CLEAR_AUTOMATIC_WASH_CODES',
  USE_WASH_CODE: 'textile/USE_WASH_CODE',
  REMOVE_WASH_CODE: 'textile/REMOVE_WASH_CODE',
};
